<template>
<div>
    <div class="data-table-inner">
        <div class="row data-table-control">
            <div class="col-md-6">
                <div class="form-group">
                    <label>
                        Mostrar
                        <select class="custom-select custom-select-sm" v-model="itemsPerPage">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                        </select>
                        Filas
                    </label>

                </div>
            </div>
            <!-- <div class="col-md-6">
                <div class="form-group">
                    <input type="text" class="form-control form-control-sm" placeholder="Search Records" @keyup="search(query)" v-model="query">
                </div>
            </div> -->
            <!-- <div class="col-auto ml-auto" v-if="showFilters">
                Filtros:
                <div class="table-filters d-inline-block">
                    <div class="table-filter" v-for="option in filters" @click="filter(option)">
                        <span>{{ option.title }}</span>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Cronómetro</th>
                        <th>Estado</th>
                        <th>intención</th>
                        <th>Agente </th>
                        <th>Cliente </th>
                        <th>Número</th>
                        <th>Canal</th>
                        <th>Ultima Actualización </th>
                        <th>Opciones</th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="inter in paginatedItems" :key="inter.id">
                        <td>
                            <span v-if="inter.nombre_estado === 'Pendiente'">
                                <CronometroComponent :delta="parseInt(inter.nombre_estado == 'Pendiente' ? (inter.diff || 0) : 0)">
                                </CronometroComponent>
                            </span>
                        </td>
                        <td><span class="label " :class="{
                            'label-warning': inter.nombre_estado === 'Pendiente',
                            'label-primary': inter.nombre_estado === 'Contestada',
                            'label-success': inter.nombre_estado === 'Transferida'
                            }">{{inter.nombre_estado}}</span></td>
                        <td>{{inter.intencion}}</td>
                        <td>{{inter.nombre_agente}}</td>
                        <td>{{inter.nombre_paciente}}</td>
                        <td>{{inter.emisor}}</td>
                        <td><span v-for="canal in inter.canales">
                                {{canal}}
                            </span></td>
                        <td>{{inter.lastUpdate}}</td>
                        <td>
                            <div class="btn-group">
                                <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle"> Opciones</button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" @click.prevent="mostrarModalHistorial(inter.id_inter_global)"> Ver Historial</a></li>
                                    <li><a class="dropdown-item" v-if="inter.nombre_estado === 'Contestada'" @click.prevent="mostrarModalTransferir(inter.id_inter_global)"> Transferir</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="showing">
                    Mostrando
                    <!-- Current Page Starting Index -->
                    {{ paginatedItems.length ? (itemsPerPage * (currentPage - 1)) + 1 : 0 }}
                    a
                    <!-- Current Page End Index -->
                    {{ (itemsPerPage * (currentPage -1 )) + paginatedItems.length }}
                    de
                    <!-- All Items Provided -->
                    {{ renderedItems.length }} Filas
                </div>
            </div>
            <div class="col-md-6">
                <ul class="pagination" v-if="paginateLinks.length">
                    <li class="page-item" v-if="pages && currentPage != 1">
                        <span class="page-link" @click="prev">Prev</span>
                    </li>
                    <li class="page-item" v-bind:key="item.page" v-for="item in paginateLinks" :class="{active: currentPage == item.page}">
                        <span class="page-link" @click="paginate(item.page)">{{ item.page }}</span>
                    </li>
                    <li class="page-item" v-if="pages && currentPage < pages">
                        <span class="page-link" @click="next">Next</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <transferir-modal-component ref="ModalTransferir" />
    <historial-modal-component ref="ModalHistorial" />
</div>
</template>

<script>
import TransferirModalComponent from "../../modals/TransferirModalComponent";
import HistorialModalComponent from "../../modals//HistorialModalComponent";
import CronometroComponent from "./CronometroComponent";
var moment = require('moment');
export default {
    components: { TransferirModalComponent, HistorialModalComponent, CronometroComponent },
    props: ['data'],
    mounted() {
        this.items = this.data;
        // console.log(this.items);
    },
    data() {
        return {
            itemsPerPage: 100,
            currentPage: 1,
            // Current Page Items
            paginatedItems: [],
            renderedItems: [],
            length_data: 0
        }
    },
    comments: {
        TransferirModalComponent,
        HistorialModalComponent,
        CronometroComponent
    },
    computed: {
        // Total Number Of Pages For Pagination
        pages() {
            if (this.renderedItems.length > this.itemsPerPage) {
                return Math.ceil(this.renderedItems.length / this.itemsPerPage);
            } else {
                return 0;
            }
        },
        // Array Of Links With Page Number For Pagination
        paginateLinks() {
            var links = [];
            var approved = [];
            let center = Math.round(this.pages / 2) - 1;
            for (var i = 0; i < this.pages; i++) {
                if (this.pages > 6) {
                    let difference = this.currentPage - i;
                    let centerDifference = center - i;
                    // around the current page
                    if (!(difference < 0) && !(difference > 2)) {
                        // around the center
                    } else if (i === center) {
                        // at the start or end
                    } else if (this.pages - i <= 2 || i <= 1) {
                        // everywhere else
                    } else {
                        continue;
                    }
                }
                links.push({ page: i + 1 });
            }
            return links;
        },
    },
    watch: {
        currentPage(newValue) {
            this.paginatedItems = this.renderedItems.slice(this.itemsPerPage * (newValue - 1), (this.itemsPerPage * newValue));
        },
        itemsPerPage(newValue) {
            this.currentPage = 1;
            this.paginatedItems = this.renderedItems.slice(newValue * (this.currentPage - 1), (newValue * this.currentPage));
        },
        items(newValue) {
            // this.getHeaders();

        },
        data(newValue) {
            // this.items = newValue;
            this.renderedItems = newValue;
            if (this.length_data < newValue.length) {
                console.log("ENTRE");
                this.sortDate();
                this.length_data = newValue.length;
            }
            // Get All Items In Current Page
            this.paginatedItems = this.renderedItems.slice(this.itemsPerPage * (this.currentPage - 1), (this.itemsPerPage * this.currentPage));

            this.asc = true;
            // console.log("ENTRE");
            // console.log(newValue);
            // this.sortDate();
            // this.sortIndex();
        },
        renderedItems(newValue) {
            this.paginatedItems = newValue.slice(this.itemsPerPage * (this.currentPage - 1), (this.itemsPerPage * this.currentPage));
        }
    },
    methods: {
        mostrarModalTransferir(inter_global) {
            this.inter_global = inter_global
            this.$refs.ModalTransferir.show(inter_global)
        },
        mostrarModalHistorial(inter_global) {
            console.log(inter_global);
            this.inter_global = inter_global
            this.$refs.ModalHistorial.show(inter_global)
        },
        paginate(page) {
            this.currentPage = page;
        },
        // Navigate To Next Page
        next() {
            this.currentPage = this.currentPage >= this.renderedItems.length ? 0 : this.currentPage + 1;
        },
        // Navigate To Previous Page
        prev() {
            this.currentPage = this.currentPage <= 0 ? this.renderedItems.length : this.currentPage - 1;
        },
        // Navigate To Last Page
        end() {
            this.currentPage = this.renderedItems.length;
        },
        // Navigate To First Page
        start() {
            this.currentPage = 1;
        },
        sort(column) {

            this.renderedItems = this.renderedItems.sort((a, b) => {
                var detailx = a.details.find(detail => detail.name == column);
                var x = detailx.rendered;
                if (!x) {

                }
                x = typeof x == 'string' ? x.toLowerCase() : x;
                var detaily = b.details.find(detail => detail.name == column);
                var y = detaily.rendered;
                if (!x) {

                }
                y = typeof y == 'string' ? y.toLowerCase() : y;
                return x > y ? 1 : -1;
            });
            if (column !== this.sortColumn) {
                this.asc = true;
            } else {
                this.asc = !this.asc;
            }

            if (!this.asc) {
                this.renderedItems = this.renderedItems.reverse();
            }
            this.sortColumn = column;

            this.currentPage = 1;
        },

        sortIndex(asc) {
            this.renderedItems = this.renderedItems.sort((a, b) => {
                var indexA = a.index;
                var indexB = b.index;
                return indexA > indexB ? 1 : -1;
            });
            this.asc = this.sortColumn == '#' ? !this.asc : true;

            if (asc != undefined) {
                if (!asc) {
                    // console.log(this.renderedItems);
                    this.renderedItems = this.renderedItems.reverse();
                }
            } else {
                if (!this.asc) {
                    this.renderedItems = this.renderedItems.reverse();
                }
            }

            this.sortColumn = '#';

            this.currentPage = 1;
        },
        sortDate() {
            this.data.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                if (a.lastUpdate && b.lastUpdate) {
                    return new Date(b.lastUpdate) - new Date(a.lastUpdate);
                } else
                    return 1;
            });
        },
        mapItems(items) {
            items = items.map((item, index) => {
                // Row Item
                var row = {
                    row: item,
                    details: [],
                    index,
                    buttons: [],
                    selected: !!this.selected.find(a => a.index == index)
                };

                // Get Provided Columns
                this.columns.forEach((column, index2) => {

                    row.details.push({
                        // Item Column Name
                        name: column.name,
                        // Table Header Title
                        th: column.th,
                        // Provided Value
                        value: item[column.name],
                        // Decide Value Depending On Whether Render Method Is Provided
                        rendered: column.render ? column.render(item, item[column.name], index) : item[column.name],
                        // Origin Item Row
                        row: item,
                        // Whether Or Not To Display Item
                        show: column.show !== false,
                        // Click Event For Column
                        click: column.click
                    });

                });

                // Get Provided Actions
                this.actions.forEach((button, index3) => {

                    row.buttons.push({
                        // Spread Provided Button Properties
                        ...button,
                        // Decide Visibility Depending On Whether Show Method Is Provided
                        // Default: true
                        show: button.show ? button.show(item, index) : true,
                        disabled: button.disabled ? button.disabled(item, index) : false
                    });

                });

                return row;
            });
            return items;
        },
    },

}
</script>
